// removed by extract-text-webpack-plugin
module.exports = {"potential-client-settings":"potential-client-settings","classtop-panel":"classtop-panel","content-section":"content-section","bread-crumbs":"bread-crumbs"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/PotentialClientSettings/PotentialClientSettings.scss
// module id = em7t
// module chunks = 0